import { ChevronUp, ChevronDown, GripVertical } from "lucide-react";

// PATCH 36 Me11 — drag-free reorder handle for a home-screen widget. Pairs with useWidgetOrder.
export default function ReorderHandle({ onUp, onDown, isFirst, isLast, testid }) {
  return (
    <span className="k-no-print" data-testid={testid} style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
      <GripVertical size={13} className="k-muted" aria-hidden="true" />
      <button className="k-link" aria-label="Move up" data-testid={`${testid}-up`} disabled={isFirst}
        onClick={onUp} style={{ opacity: isFirst ? 0.3 : 1, lineHeight: 0 }}><ChevronUp size={15} /></button>
      <button className="k-link" aria-label="Move down" data-testid={`${testid}-down`} disabled={isLast}
        onClick={onDown} style={{ opacity: isLast ? 0.3 : 1, lineHeight: 0 }}><ChevronDown size={15} /></button>
    </span>
  );
}
